import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useBreakpointUp } from '@travel-frontend/core';
import { IconMagicDust } from '@travel-frontend/icons';
import { useTranslation } from 'next-i18next';
import { Badge } from '../../../../../../components/HotelDetailsOverlay/components/AmadeusRatingSection/components/Badge.js';
import { Flex, HeadlineMedium, LabelXSmall, ParagraphMedium } from '../../../../../../primitives/index.js';
import { qaId } from '../../../../../../utils/index.js';
import { HOTEL_DETAILS_QA_ID } from '../../../../../../utils/qaId.js';
export const AISummary = ({
  summaryText
}) => {
  const {
    t
  } = useTranslation('hotelDetailsOverlay');
  const lgUp = useBreakpointUp('lg');
  return _jsxs(Flex, {
    children: [_jsxs(Flex, {
      gap: "8px",
      children: [_jsxs(Flex, {
        direction: "row",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 0,
        children: [_jsx(HeadlineMedium, {
          "data-testid": qaId(HOTEL_DETAILS_QA_ID, 'ai-summary-headline'),
          children: t('hotelDetailsOverlay:AISummary.title')
        }), _jsx(Badge, {
          icon: _jsx(IconMagicDust, {
            fontScale: "16px"
          }),
          children: t('AISummary.badge')
        })]
      }), lgUp && _jsx(LabelXSmall, {
        color: "contentSecondary",
        children: t('AISummary.subtitle')
      })]
    }), _jsx(Flex, {
      children: _jsx(ParagraphMedium, {
        children: summaryText
      })
    })]
  });
};